import React, { Component } from 'react';
import Decorator from '../../functions/decorator';

const FullBanner = function(props) {
    return (
        <div className="container-fluid p-0">
            <div className="row">
                <div className="col-lg pt-2 text-center">
                    <img style={{maxHeight: '300px'}} className='img-fluid' src={props.children.imageLarge} alt={props.children.description}/>
                </div>
            </div>
            <div className="col-md text-center">
                {/*<hr className="store-bg-accent w-50"/>*/}
                {props.children.useLargeText ? <h1 className="mt-0">{props.children.editing ? <span className='store-fg-primary'>Editing: </span> : ''} {props.children.headerText}</h1> : <h2 className="mt-0">{props.children.editing ? <span className='store-fg-primary'>Editing: </span> : ''} {props.children.headerText}</h2>}
                {/*<hr className="store-bg-accent w-50"/>*/}
                <i>{props.children.description ? Decorator.multiLineParagraph(props.children.description, 'h6') : ''}</i>
            </div>
            {props.children.alternateSection ? <div className="col-md">
                {props.children.alternateSection}
            </div> : ''}
        </div>
    )
};

export default FullBanner;
